// import React from "react"
import { cryptoOrders, wallet } from "./crypto"
import { invoiceList } from "./invoices"
import { tasks } from "./tasks"
import {
  cartData,
  comments,
  customerData,
  discountData,
  orders,
  productsData,
  recentProducts,
  shops,
} from "./ecommerce"
import { chats, contacts, groups, messages } from "./chat"
import { calenderDefaultCategories, events } from "./calender"
import { users, userProfile } from "./contacts"

export {
  productsData,
  discountData,
  events,
  calenderDefaultCategories,
  chats,
  groups,
  contacts,
  messages,
  orders,
  cartData,
  customerData,
  shops,
  recentProducts,
  comments,
  wallet,
  cryptoOrders,
  invoiceList,
  tasks,
  users,
  userProfile,
}
